import React from 'react'

// Bundled wide grounds shot used until a property-specific photo is set
// on theme.coverImageUrl. Set coverImageUrl to 'none' to render no hero.
const DEFAULT_COVER_IMAGE = '/build/images/proposals/cover_hero.webp'

// Full-bleed brand cover: photo hero with scrim, entity logo top-left,
// client name as the title, contact + prepared-by blocks. No pricing.
const CoverPage = ({ data, theme, crmSnapshot, variables }) => {
  const configured = theme?.coverImageUrl || data?.heroImageUrl || ''
  const heroUrl = configured === 'none' ? '' : (configured || DEFAULT_COVER_IMAGE)
  const preparedLine = [
    crmSnapshot?.contactName ? `Prepared for ${crmSnapshot.contactName}` : '',
    crmSnapshot?.contractDate || ''
  ].filter(Boolean).join(' · ')

  return (
    <div className="proposal-cover">
      <div className="proposal-cover__accent-bar" />

      <div className={'proposal-cover__hero' + (heroUrl ? '' : ' proposal-cover__hero--empty')}>
        {heroUrl && <img className="proposal-cover__hero-img" src={heroUrl} alt="" />}
        <div className="proposal-cover__hero-scrim" />
      </div>

      <div className="proposal-cover__body">
        <div>
          <div className="proposal-cover__eyebrow">{data?.subtitle || 'Landscape Maintenance Proposal'}</div>
          <div className="proposal-cover__rule" />
          <div className="proposal-cover__title">{crmSnapshot?.clientName || data?.tagline || 'Client Name'}</div>
          {crmSnapshot?.clientAddress && <div className="proposal-cover__address">{crmSnapshot.clientAddress}</div>}
          {preparedLine && <div className="proposal-cover__prepared-for">{preparedLine}</div>}
        </div>

        {/* Bottom row: prepared-by/copyright left, logo on a white plate right
            (the plate keeps any logo legible over the photo/green). */}
        <div className="proposal-cover__bottom">
          <div className="proposal-cover__bottom-left">
            {(crmSnapshot?.yourCompany || crmSnapshot?.yourName || crmSnapshot?.yourEmail) && (
              <div className="proposal-cover__prepared-by">
                {crmSnapshot?.yourCompany && <div className="proposal-cover__prepared-by-company">Prepared by {crmSnapshot.yourCompany}</div>}
                {crmSnapshot?.yourName && <div>{[crmSnapshot.yourName, crmSnapshot.yourTitle].filter(Boolean).join(', ')}</div>}
                {(crmSnapshot?.yourEmail || crmSnapshot?.yourPhone) && (
                  <div>{[crmSnapshot?.yourEmail, crmSnapshot?.yourPhone].filter(Boolean).join(' · ')}</div>
                )}
              </div>
            )}
            <div className="proposal-cover__copyright">
              &copy;{new Date().getFullYear()} {variables?.entityNameFormal || 'Handyman Maintenance, Inc.'} &middot; All Rights Reserved
            </div>
          </div>
          {theme?.logoUrl && (
            <div className="proposal-cover__logo-plate">
              <img src={theme.logoUrl} alt="Company Logo" style={{ maxWidth: theme?.logoWidth || 180 }} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CoverPage
